import {
  ApplicationState,
  CancelledPlan,
  CapturedPayment,
  EndedPaymentPlan,
  OngoingPaymentPlan,
  Plan,
} from '../../Dashboard.types';
import { useIwocaPayApplication } from '../../hooks/useIwocaPayApplication';
import { renderSelectedComponent } from '../../renderSelectedComponent';
import { DeclinedApplication } from '../DeclinedApplication/DeclinedApplication';
import { NoPlansView } from '../NoPlansView/NoPlansView';
import { PaymentPlans } from '../PaymentPlans/PaymentPlans';
import { SelectedView } from '../SelectedView/SelectedView';

export function AccountPlansSection({
  isMobile,
  application,
  ongoingPaymentPlans,
  capturedPlans,
  cancelledPayments,
  endedPayments,
  selectedPlan,
  selectPaymentPlan,
  setIsSpendingLimitDrawerOpen,
  loadingRefreshSpendingLimit,
  handleRefreshSpendingLimit,
}: {
  isMobile: boolean;
  application: ApplicationState;
  ongoingPaymentPlans: OngoingPaymentPlan[];
  capturedPlans: CapturedPayment[];
  cancelledPayments: CancelledPlan[];
  endedPayments: EndedPaymentPlan[];
  selectedPlan: Plan | null;
  selectPaymentPlan: (plan: Plan) => void;
  setIsSpendingLimitDrawerOpen: React.Dispatch<React.SetStateAction<boolean>>;
  loadingRefreshSpendingLimit: boolean;
  handleRefreshSpendingLimit: () => Promise<void>;
}) {
  const iwocaPayApplication = useIwocaPayApplication();

  const hasPaymentPlans =
    application?.payLink ||
    capturedPlans.length > 0 ||
    ongoingPaymentPlans.length > 0 ||
    cancelledPayments.length > 0 ||
    endedPayments.length > 0;

  if (!hasPaymentPlans) {
    if (!iwocaPayApplication) return null;

    switch (iwocaPayApplication.status) {
      case 'declined':
        return <DeclinedApplication />;
      default:
        return (
          <NoPlansView
            setIsSpendingLimitDrawerOpen={setIsSpendingLimitDrawerOpen}
            loadingRefreshSpendingLimit={loadingRefreshSpendingLimit}
            refreshSpendingLimit={handleRefreshSpendingLimit}
          />
        );
    }
  }

  return (
    <>
      <section style={{ gridArea: 'plans' }}>
        <PaymentPlans
          endedPayments={endedPayments}
          ongoingPaymentPlans={ongoingPaymentPlans}
          capturedPlans={capturedPlans}
          cancelledPayments={cancelledPayments}
          selectedPlan={selectedPlan}
          selectPaymentPlan={selectPaymentPlan}
          renderContent={() => renderSelectedComponent(selectedPlan)}
        />
      </section>
      {!isMobile && (
        <section style={{ gridArea: 'plan' }}>
          <SelectedView plan={selectedPlan}>
            {renderSelectedComponent(selectedPlan)}
          </SelectedView>
        </section>
      )}
    </>
  );
}
